import { FormCheck } from 'components/form/FormCheck';
import { getPrivacyConsentConfig } from 'helpers/privacyConsent';
import { classNames, React } from 'libs/react';
import './PublicLegalConsent.scss';
/**
 * @component PublicLegalConsent
 * @since 1.0.0
 */
export function PublicLegalConsent(props) {
    const { className, configurationFields, language, privacyAccepted, marketingOptIn, onPrivacyAcceptedChange, onMarketingOptInChange } = props;
    const { collectMarketing, marketingLabel, privacyPolicyUrl } = getPrivacyConsentConfig(configurationFields, language);
    return (React.createElement("div", { className: classNames('public-legal-consent', className) },
        React.createElement("p", { className: "public-legal-consent__notice" },
            t('The information collected is used to process your request. You may access, correct, or withdraw your consent at any time. See our'),
            ' ',
            React.createElement("a", { href: privacyPolicyUrl, target: "_blank", rel: "noreferrer" }, t('privacy policy.'))),
        React.createElement("div", { className: "public-legal-consent__check" },
            React.createElement(FormCheck, { name: "privacyAccepted", checked: privacyAccepted, onChange: onPrivacyAcceptedChange, label: t('I have read and accept the privacy policy.') })),
        collectMarketing && (React.createElement("div", { className: "public-legal-consent__check" },
            React.createElement(FormCheck, { name: "marketingOptIn", checked: marketingOptIn, onChange: onMarketingOptInChange, label: marketingLabel })))));
}
